import { render, staticRenderFns } from "./BdMain.vue?vue&type=template&id=266df725&scoped=true&"
import script from "./BdMain.vue?vue&type=script&lang=js&"
export * from "./BdMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266df725",
  null
  
)

export default component.exports